import { memo } from 'react';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

export type FilterOptionItemProps = {
  option: { id: number | string; label: string };
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  baseId: string;
};

export const FilterOptionItem = memo(function FilterOptionItem({
  option,
  checked,
  onCheckedChange,
  baseId,
}: FilterOptionItemProps) {
  const { id, label } = option;
  const optionDomId = `${baseId}-opt-${id}`;

  function handleClick() {
    onCheckedChange(!checked);
  }

  return (
    <Button
      variant="ghost"
      asChild
      data-testid="filter-option-item"
      className="hover:bg-muted h-auto w-full rounded-sm px-2 py-1.5 font-normal"
      onClick={handleClick}
    >
      <div className="flex w-full items-center justify-start gap-2">
        <Checkbox id={optionDomId} checked={checked} className="pointer-events-none" />
        <Label htmlFor={optionDomId} className="pointer-events-none truncate text-sm font-normal">
          {label}
        </Label>
      </div>
    </Button>
  );
});
